import axios from "axios"

export function getCountries(){ 

    return axios
            .get("v1/coach/country/")
            .then(response => response.data.countries);
}